import useStyles from '../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import EAIcon from '../../../../../components/common/EAIcon';
import i18next from 'i18next';
import React from 'react';
import ResultValueField from "./ResultValueField";
import ColorPickerField from "./ColorPickerField";

const DefaultPresentation = ({ data, fieldName, resultType, readOnly = false }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.defaultBranch}>
      <div className={classes.defaultBranchNotice}>
        <EAIcon icon={"warning-snack"} />
        <span>{i18next.t("calculator.dialog.create.defaultBranchNotice")}</span>
      </div>
      <div className={classes.defaultBranchForm}>
        <ResultValueField
          fieldName={`${fieldName}.resultValue`}
          resultType={resultType}
          disabled={readOnly}
        />
        <div style={{ position: "relative" }}>
          <ColorPickerField
            fieldName={`${fieldName}.resultColorCode`}
            defaultValue={data?.resultColorCode}
            disabled={readOnly}
          />
        </div>
      </div>
    </div>
  )
}

export default DefaultPresentation;